import {StatusBarStyle} from 'react-native';
import Styles from 'src/components/Styles';

export function statusBarStyleDescriptor(): StatusBarStyle {
  return 'light-content';
}
export function welcomeScreenstatusBarStyleDescriptor(): StatusBarStyle {
  return 'dark-content';
}

export function statusBarBackgroundColorDescriptor(): string {
  return Styles.darkBlueRevolveColor;
}

export default {
  statusBarStyleDescriptor,
  statusBarBackgroundColorDescriptor,
  welcomeScreenstatusBarStyleDescriptor,
};
